export default {
  index: [
    {
      path: '/expensereimburseDetails',
      component: resolve => require(['./expensereimburseDetailsIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/expensereimburseDetails/_router.js